import React, { useEffect, useState } from "react";
import { TICKER as FALLBACK } from "../mock";
import { TrendingUp, TrendingDown } from "lucide-react";
import { api } from "../lib/api";

const fmt = (v, decimals) => {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  return n.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

const TickerItem = ({ t }) => {
  const up = (t.change ?? 0) >= 0;
  const Icon = up ? TrendingUp : TrendingDown;
  const decimals = t.decimals ?? 2;
  return (
    <div className="inline-flex items-center gap-2 px-5 py-1 border-r border-white/[0.06]">
      <span className="font-mono-tick text-[11px] tracking-wider text-[#8ba5c1]">{t.symbol}</span>
      <span className="font-mono-tick text-[13px] text-[#f5f0e8] font-medium">{fmt(t.price, decimals)}</span>
      <span className={`font-mono-tick text-[11px] inline-flex items-center gap-0.5 ${up ? 'text-[#7ec091]' : 'text-[#d68787]'}`}>
        <Icon className="w-3 h-3" />
        {up ? '+' : ''}{fmt(t.change, decimals)}
      </span>
    </div>
  );
};

const TickerRow = ({ label, items, kickerBg, direction = "normal" }) => {
  if (!items || items.length === 0) return null;
  const dup = [...items, ...items];
  return (
    <div className="flex border-t border-white/[0.06] first:border-t-0">
      <div
        className={`shrink-0 px-4 py-1.5 font-semibold text-[10px] tracking-widest uppercase flex items-center ${kickerBg}`}
      >
        {label}
      </div>
      <div className="flex-1 overflow-hidden py-1.5">
        <div
          className={`inline-flex whitespace-nowrap ${direction === "reverse" ? "gf-ticker-track-reverse" : "gf-ticker-track"}`}
        >
          {dup.map((t, i) => (
            <TickerItem key={i} t={t} />
          ))}
        </div>
      </div>
    </div>
  );
};

const Ticker = () => {
  const [symbols, setSymbols] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.get("/ticker");
        if (!cancelled && r.data?.symbols?.length) {
          setSymbols(r.data.symbols);
        }
      } catch (e) {
        if (!cancelled) setSymbols(FALLBACK);
      }
    };
    load();
    const t = setInterval(load, 90 * 1000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  const data = symbols.length ? symbols : FALLBACK;
  // Consolidated single ticker: primary + intl symbols merged into one
  // continuous scroll (ZH-style compact top strip).
  const primary = data.filter((s) => (s.group || "primary") === "primary");
  const intl = data.filter((s) => s.group === "intl");
  const merged = [...primary, ...intl];

  return (
    <div className="w-full bg-[#243447] overflow-hidden relative" data-testid="market-ticker">
      <TickerRow
        label="Live Markets"
        items={merged}
        kickerBg="bg-[#9FDDE7] text-[#1a2537]"
        direction="normal"
      />
    </div>
  );
};

export default Ticker;
